<!-- components/header-edit-dialog.vue -->
<template>
  <div class="operator-box">
    <!-- 全屏切换按钮 -->
    <img v-show="screenFlag" alt="退出全屏" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/backIcon.png" @click="exitFullscreenClick" class="screen-icon" />
    <img v-show="!screenFlag" alt="进入全屏" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/screenIcon.png" @click="enterScreenClick" class="screen-icon" />
    <!-- 配置按钮 -->
    <img v-show="!screenFlag" alt="编辑配置" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/editIcon.png" @click="getMainKanbanDataDetailFun" class="edit-icon" />
    <!--选择配置分屏-->
    <el-dialog v-model="selectSetDialog" class="selectSetDialog" title="配置" width="60%" append-to-body>
      <div class="listBox" v-loading="loading">
        <el-select v-model="selectData" multiple>
          <el-option v-for="(item, index) in mainKanbanDataList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button class="resetButton" @click="selectSetDialog = false">取消</el-button>
          <el-button type="primary" @click="saveMainKanbanDataDetailFun">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, nextTick, inject, onMounted, defineEmits } from "vue";
import { useStore } from "vuex";

import { ElMessage } from "element-plus";
import { getMainKanbanDataDetailApi, getProjectModuleLIstRecursiveDownApi, saveMainKanbanDataApi } from "@/api/modules/project";
import useFullscreen from "@/hooks/useFullscreen";
const { screenFlag, enterScreenClick, exitFullscreenClick, triggerResize } = useFullscreen(".templateBigScreen4");
const emit = defineEmits(["saveKanBanSuccess"]);

// 全屏状态
// 配置弹窗状态（如果需要）
const selectSetDialog = ref(false);
// 配置数据
const selectData = ref([]);
// 父组件传入的模块ID
const props = defineProps(["projectModuleId"]);
const receiveTemplateId = inject("templateId"); // 默认值为21
const receiveProjectModuleId = inject("projectModuleId"); // 默认值为21
const receiveProjectId = inject("projectId"); // 默认值为21
let loading = ref(true);

const store = useStore();

const receiveRefreshData = inject("refreshData");
const saveMainKanbanDataDetailFun = () => {
  let datas = [];
  selectData.value.forEach((item) => {
    let dataItem = mainKanbanDataList.value.find((item1) => item == item1.id);
    datas.push({
      includeModuleId: dataItem.id,
      moduleId: receiveProjectModuleId.value,
      templateId: store.getters.getTemplateIdByType(dataItem.type) || "",
      type: dataItem.type,
    });
  });
  saveMainKanbanDataApi(datas).then((res) => {
    if (res.data.code == 200) {
      ElMessage.success("保存成功");
      selectSetDialog.value = false;
      receiveRefreshData();
    }
  });
};

let mainKanbanDataList = ref([]); //分屏列表
const getTemplateListFun = function () {
  getProjectModuleLIstRecursiveDownApi({
    projectId: receiveProjectId.value, // 可考虑通过props传入
    type: 19,
  }).then((res) => {
    if (res.data.code === 0) {
      mainKanbanDataList.value = res.data.result;
      loading.value = false;
    } else {
      ElMessage({
        type: "error",
        message: res.data.message,
      });
    }
  });
};

// 获取配置详情
const getMainKanbanDataDetailFun = () => {
  getMainKanbanDataDetailApi({
    moduleId: receiveProjectModuleId.value, // 可考虑通过props传入
    templateId: receiveTemplateId.value, // 可考虑通过props传入
  })
    .then((res) => {
      if (res.data.code === 200) {
        selectSetDialog.value = true;
        // 深拷贝数据避免引用问题
        let list = JSON.parse(JSON.stringify(res.data.data));
        // 筛选出mainKanbanDataList中存在的项
        if (mainKanbanDataList.value) {
          list = list.filter((item) => mainKanbanDataList.value.some((data) => data.id == item.includeModuleId));
        } else {
          list = [];
        }
        // 转换为字符串数组（保持原逻辑）
        selectData.value = list.map((item) => String(item.includeModuleId));
      } else {
        ElMessage.error(res.data.message || "获取配置失败");
      }
    })
    .catch((err) => {
      ElMessage.error("网络错误，获取配置失败");
    });
};

// 暴露全屏状态和配置数据供父组件使用
defineExpose({
  screenFlag,
  selectSetDialog,
  selectData,
});

onMounted(() => {
  getTemplateListFun();
  triggerResize();
});
</script>

<style scoped>
.operator-box {
  display: flex;
  gap: 12px;
  align-items: center;
  box-sizing: border-box;
  padding-right: 12px;
}

.screen-icon,
.edit-icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.screen-icon:hover,
.edit-icon:hover {
  opacity: 0.8;
}
</style>
